const baseUrl = "https://promorama-api.onrender.com/api/v1"
export const baseUrl2 = "https://promorama-api.onrender.com"

export default baseUrl;